import React, { Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Row, Col, Card, CardBody, CardHeader, CardFooter } from 'reactstrap';
import AppPagination from '../../../../Blocks/AppPagination';
import CustomerPortfolioService from '../../../../services/customer.portfolio.service';

class CustomerPortfolioNAVCCQHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            histories: null,
            totalPages: 0,
            hasPreviousPage: false,
            hasNextPage: false,
            error: '',
            errorModalOpen: false,
            isLoading: false
        };
    }

    componentDidMount() {
        this.loadNAVCCQHistories();
    }

    loadNAVCCQHistories() {
        this.setState({
            isLoading: true
        });
        let { match } = this.props;
        let page = parseInt(match.params.page) ?? 1;
        new CustomerPortfolioService().navccqHistories(match.params.portfolioId, page).then(
            response => {
                this.setState({
                    histories: response.data.items,
                    totalPages: response.data.totalPages,
                    hasPreviousPage: response.data.hasPreviousPage,
                    hasNextPage: response.data.hasNextPage,
                    isLoading: false
                });
            },
            error => {
                this.setState({
                    error: error.message,
                    isLoading: false
                })
            }
        );
    }

    render() {
        let { match } = this.props;
        let parentUrl = match.url.substring(0, match.url.lastIndexOf("/"));
        let page = parseInt(match.params.page) ?? 1;
        let { histories, hasNextPage, hasPreviousPage, totalPages, isLoading } = this.state;
        return (
            <Fragment>
                <TransitionGroup>
                    <CSSTransition
                        component="div"
                        className="TabsAnimation"
                        appear={true}
                        timeout={0}
                        enter={false}
                        exit={false}>
                        <Row>
                            {isLoading ? (
                                <div className="loader-container">
                                    <div className="loader-container-inner">
                                        <h6 className="mt-5">
                                            Hệ thống đang xử lý ...
                                        </h6>
                                    </div>
                                </div>
                            ) : (
                                <Col lg="12">
                                    <Card className="main-card mb-3">
                                        <CardHeader>
                                            <div className="card-header-title">
                                                <i className="header-icon lnr-list icon-gradient bg-plum-plate"> </i>
                                                Lịch Sử NAVCCQ
                                            </div>
                                            <div class="btn-actions-pane-right">
                                                <button class="btn btn-primary mb-2 me-2" onClick={() => this.toggleAddNAVCCQHistoryModal()}>Thêm Lịch Sử NAVCCQ</button>
                                            </div>
                                        </CardHeader>
                                        <CardBody>
                                            <div class="table-responsive">
                                                <table class="align-middle mb-0 table table-borderless table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center">Thời Gian</th>
                                                            <th class="text-center">Giá Trị</th>
                                                            <th class="text-center">Giá Trị Sau Phí</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {histories && histories.map(h => (
                                                            <tr>
                                                                <td class="text-center">
                                                                    {h.date}
                                                                </td>
                                                                <td class="text-center">
                                                                    {h.value}
                                                                </td>
                                                                <td class="text-center">
                                                                    {h.valueAfterFee}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </CardBody>
                                        <CardFooter className='justify-content-center'>
                                            <AppPagination totalPages={totalPages} parentUrl={parentUrl} page={page} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} />
                                        </CardFooter>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                    </CSSTransition>
                </TransitionGroup>
            </Fragment>
        );
    }
}

export default withRouter(CustomerPortfolioNAVCCQHistory);
